'use strict';

function Range(start, end, ease) {
	this._start = start;
	this._end = end;
	this._ease = ease;
};

Range.prototype.valueAt = function(percent) {
	if (percent > 1)
		percent = 1;
	else if (percent < 0)
		percent = 0;
	
	return this._start + ((this._end - this._start) * this._ease(percent));
};
Range.prototype.getStart = function() {
	return this._start;
};
Range.prototype.setStart = function(start) {
	this._start = start;
};
Range.prototype.getEnd = function() {
	return this._end;
};
Range.prototype.setEnd = function(end) {
	this._end = end;
};

module.exports = Range; 
